import { Button, ButtonProps, Dialog } from "@validereinc/common-components";
import React from "react";

export const WorkflowConfigurationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  buttonLabel,
  message,
  buttonVariant = "primary",
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  buttonLabel: string;
  buttonVariant?: ButtonProps["variant"];
}) => {
  return (
    <Dialog
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      actionRow={[
        <Button
          key="confirmation-button"
          variant={buttonVariant}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {buttonLabel}
        </Button>,
      ]}
    >
      {message}
    </Dialog>
  );
};
